import { useQuery } from "@tanstack/react-query"

import { listLots } from "@/features/lots/api/lots.api"
import type {
  LotListItemWithQC,
  ListLotsParams,
} from "@/features/lots/api/types"

// Wraps `listLots` for the New OT wizard's lot picker. Always
// `status=COMPLETED` and `includeQc=true` so `lotQCWarning(lot, contractId)`
// can decorate each candidate row.
//
// Cache key is distinct from the regular `useLots` query so toggling the
// wizard doesn't poison the lots-page cache with QC embeds.
export function useLotsForOT(extra: ListLotsParams = {}) {
  const params: ListLotsParams = {
    status: "COMPLETED",
    includeQc: true,
    available: true,
    ...extra,
  }
  return useQuery({
    queryKey: ["transit", "lots-picker", params],
    queryFn: async () => {
      const list = await listLots(params)
      return list as LotListItemWithQC[]
    },
  })
}
